// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase, TelemetryType } from "@msnews/telemetry-contracts";
import { genericTelemetryClickDispatcher, getPageContentType } from "../../Social.telemetry";

export interface ContentPanelTelemetryObjects {
    guidelinesLink: TelemetryObjectBase;
}

export const contentPanelTelemetryContracts = {
    /** Comments-Scenario-3 */
    guidelinesLink: {
        name: "CommunityGuidelines",
        behavior: TelemetryBehaviorType.Navigate,
        content: {
            type: getPageContentType(),
            headline: "CommunityGuidelines"
        }
    }
};